module.exports = __webpack_public_path__ + "static/iotex_network-f36e8271fe1319122c1efad5aaff33c0.jpg";